module.exports = __webpack_public_path__ + "img/superoffice-logo.14bfcbba.svg";